var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccessory161(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 293,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32 -357)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M277.953 362.457C269.733 358.947 260.19 361.971 255.472 369.476L164.753 513.463C161.269 519.024 161.069 526.007 164.281 531.731 167.474 537.454 173.534 541 180.139 541L234.571 541C242.899 541 250.156 535.385 252.17 527.357L288.458 383.371C290.617 374.804 286.172 365.912 277.953 362.457Z",
    fill: "#F5F8FA",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.692 505.111C188.895 505.111 179.603 507.103 171.089 510.635 161.309 496.382 144.95 487 126.385 487 96.4493 487 72.1539 511.341 72.1539 541.333 72.1539 542.438 72.407 543.471 72.4793 544.557 51.2932 551.947 36.0001 571.905 36.0001 595.667 36.0001 625.677 60.2774 650 90.2308 650 111.959 650 130.56 637.123 139.201 618.65 152.271 637.558 173.999 650 198.692 650 238.624 650 271 617.563 271 577.556 271 537.548 238.624 505.111 198.692 505.111Z",
    fill: "#E1E8ED",
    fillRule: "evenodd",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessory161);
export default __webpack_public_path__ + "static/media/accessory16-1.640d6a4ee331bd6c2e449fe9a2314b3c.svg";
export { ForwardRef as ReactComponent };